import { createFileRoute } from '@tanstack/react-router';
import { PageLayout } from '@interxfi/app-components/components/layout/page-layout/page-layout';
import { TriggersTable } from '../../../../../../../features/meta/trigger/triggers-table';
import { getPageHead } from '../../../../../../../util/routing/meta';

export const Route = createFileRoute('/_app/_o5/_o5-required/tech-ops/trigger/_trigger/')({
  head: () => getPageHead('Triggers'),
  component: TriggersList,
});

function TriggersList() {
  return (
    <PageLayout>
      <PageLayout.Section noBorder>
        <TriggersTable audience="tech-ops" />
      </PageLayout.Section>
    </PageLayout>
  );
}
